export default __webpack_public_path__ + "static/media/work_with_purpose.e8729702.png";